module.exports = __webpack_public_path__ + "img/39.dc4af6a6.jpg";